import React from 'react'

const Button = (props) => {
    const { user } = props;
    return (
        <React.Fragment>
            {user? <a className="btn btn-secondary" href={`/desk/clients/${user.id}/users/${user.id}`}>ユーザを表示</a> :
                <a className="btn btn-secondary disabled" aria-disabled="true" href="#">ユーザがいません</a>  }
        </React.Fragment>
    )
}

export default Button
